<template>
    <span class="badge" :class="['badge--' + type, 'badge--' + size]">
        <slot/>
    </span>
</template>

<script>
export default {
    name: 'badge',
    props: {
        size: {
            type: String,
            default: 'small',
        },
        type: {
            type: String,
            default: 'blank',
        },
    },
};
</script>

<style lang="scss">
$block: 'badge';

// Base Badge
.#{$block} {
    display: inline-block;
    padding: 6px 25px;

    color: #fff;
    font-weight: 400;
    text-align: center;

    border-radius: 1000px;

    & + .#{$block},
    & + .button {
        margin-left: 5px;
    }
}

.badge-container + .badge {
    margin-left: 5px;
}

// Small Badge
.#{$block}--small {
    font-size: 12px;
    padding: 4px 16px;
}

// Alert Badge
.#{$block}--alert {
    background: $color-danger;
}

// Error Badge
.#{$block}--error {
    background: $color-warning;
}

// Success Badge
.#{$block}--success {
    background: $color-success;
}

// Blank Badge
.#{$block}--blank {
    background: $color-gray-another;
}
</style>
